"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = __importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var core_2 = require("@material-ui/core");
var core_3 = require("@material-ui/core");
var merge_1 = __importDefault(require("lodash/merge"));
var MaterialInputControl = /** @class */ (function (_super) {
    __extends(MaterialInputControl, _super);
    function MaterialInputControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialInputControl.prototype.render = function () {
        var _a = this.props, id = _a.id, description = _a.description, errors = _a.errors, label = _a.label, uischema = _a.uischema, visible = _a.visible, required = _a.required, config = _a.config, input = _a.input;
        var isValid = errors.length === 0;
        var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
        var inputLabelStyle = {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // magic width as the label is transformed to 75% of its size
            width: '125%'
        };
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        var firstFormHelperText = showDescription
            ? description
            : !isValid
                ? errors
                : null;
        var secondFormHelperText = showDescription && !isValid ? errors : null;
        var InnerComponent = input;
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(core_3.FormControl, { fullWidth: !appliedUiSchemaOptions.trim, onFocus: this.onFocus, onBlur: this.onBlur, id: id },
                react_1.default.createElement(core_2.InputLabel, { htmlFor: id + '-input', error: !isValid, style: inputLabelStyle }, core_1.computeLabel(core_1.isPlainLabel(label) ? label : label.default, required, appliedUiSchemaOptions.hideRequiredAsterisk)),
                react_1.default.createElement(InnerComponent, __assign({}, this.props, { id: id + '-input', isValid: isValid, visible: visible })),
                react_1.default.createElement(core_3.FormHelperText, { error: !isValid && !showDescription }, firstFormHelperText),
                react_1.default.createElement(core_3.FormHelperText, { error: !isValid }, secondFormHelperText))));
    };
    return MaterialInputControl;
}(react_2.Control));
exports.MaterialInputControl = MaterialInputControl;
//# sourceMappingURL=MaterialInputControl.js.map